<template>
  <div class="rm-screen">
    <div v-if="!selectedCompany" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("report_mobile.employees_pick_company") }}
    </div>
    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <div v-if="rows.length" class="rm-stats">
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("users") }}</span>
          <span class="rm-stat__value rm-num">{{ rows.length }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("spent_on_credits") }}{{ currencySuffix }}</span>
          <span class="rm-stat__value rm-num">{{ money(sums.spent) }}</span>
        </div>
        <div class="rm-stat rm-stat--accent">
          <span class="rm-stat__label">{{ $t("credit_balance") }}{{ currencySuffix }}</span>
          <span class="rm-stat__value rm-num">{{ money(sums.balance) }}</span>
        </div>
      </div>

      <ul v-if="rows.length" class="rm-list rm-card">
        <li v-for="row in rows" :key="row.key" class="gm-user">
          <button type="button" class="gm-user__btn" @click="openUser(row)">
            <span class="gm-user__text">
              <span class="gm-user__name">{{ row.name }}</span>
              <span class="gm-user__meta rm-num">{{ row.meta }}</span>
            </span>
            <span class="mc-balance rm-num" :class="{ 'is-negative': row.balance < 0 }">{{ money(row.balance) }}</span>
            <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
          </button>
        </li>
      </ul>
      <div v-else class="rm-empty">
        <v-icon v-if="!filters.search" size="40" color="#8a817a">mdi-account-cash-outline</v-icon>
        {{ emptyTitle }}
      </div>
    </template>
  </div>
</template>

<script>
import ReportCreditTabUsers from "@/components/report/more-restaurants/tabs/ReportCreditTabUsers.vue";
import hasMoreCreditRows from "../../../shared/more/hasMoreCreditRows";
import "../group/groupMobileUsers.scss";

/**
 * Mobilni "Kreditni korisnici" (firme koje hrani restoran): po korisniku broj narudžbi, potrošeni kredit i stanje
 * kredita (crveno kad je u minusu). Klik na korisnika otvara njegove narudžbe po mesecima. Firma i period su u
 * zaglavlju, pretraga (ime ili ID) u lupi. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "MoreMobileCredit",
  extends: ReportCreditTabUsers,
  mixins: [hasMoreCreditRows],
  computed: {
    rows() {
      return [...this.matchedRows]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((row) => ({
          ...row,
          meta: [`ID ${row.id}`, `${this.$t("orders")} ${row.ordersCount}`, `${this.$t("spent_on_credits")} ${this.money(row.spent)}`].join(" · "),
        }));
    },
  },
  methods: {
    money(value) {
      return (Number(value) || 0).toFixed(2);
    },
    /** Korisnik za pregled po mesecima (store: report/selectedEmployee, sa oznakom `credit`). */
    openUser(row) {
      const company = this.selectedCompany;
      this.$store.commit("report/SET_SELECTED_EMPLOYEE", {
        id: row.id,
        name: row.name,
        lastname: "",
        fullName: row.name,
        companyId: company && company.id,
        companyName: this.toLatin((company && (company.name || company.company)) || ""),
        credit: true,
      });
      this.$emit("open-screen", "creditUser");
    },
  },
};
</script>

<style lang="scss">
.rm-theme .mc-balance {
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;

  &.is-negative {
    color: var(--rm-accent-strong);
  }
}
</style>
